import i18n from '@/plugins/vue-i18n';
export class Banking {
  constructor(props) {
    return [
      { code: "000", name: i18n.t('bank.000'), name_en: "PromptPay" },
      { code: "002", name: i18n.t('bank.002'), name_en: "Bangkok Bank" },
      { code: "004", name: i18n.t('bank.004'), name_en: "Kasikorn Bank" },
      { code: "006", name: i18n.t('bank.006'), name_en: "Krung Thai Bank" },
      { code: "011", name: i18n.t('bank.011'), name_en: "Thai Military Bank" },
      {
        code: "014",
        name: i18n.t('bank.014'),
        name_en: "Siam Commercial Bank"
      },
      {
        code: "025",
        name: i18n.t('bank.025'),
        name_en: "Bank of Ayudhya"
      },
      {
        code: "030",
        name: i18n.t('bank.030'),
        name_en: "Government Savings Bank"
      },
      {
        code: "033",
        name: i18n.t('bank.033'),
        name_en: "Government Housing Bank"
      },
      {
        code: "034",
        name: i18n.t('bank.034'),
        name_en: "Bank for Agriculture and Agricultural Cooperatives"
      },
      { code: "065", name: i18n.t('bank.065'), name_en: "Thanachart Bank" },
      {
        code: "069",
        name: i18n.t('bank.069'),
        name_en: "Kiatnakin Bank"
      },
      { code: "022", name: i18n.t('bank.022'), name_en: "CIMB" },
      {
        code: "066",
        name: i18n.t('bank.066'),
        name_en: "Islamic Bank (Thailand)"
      },
      { code: "067", name: i18n.t('bank.067'), name_en: "TISCO Bank" },
      { code: "024", name: i18n.t('bank.024'), name_en: "UOB" },
      {
        code: "073",
        name: i18n.t('bank.073'),
        name_en: "Land and House Bank"
      },
      {
        code: "070",
        name: i18n.t('bank.070'),
        name_en: "ICBC (Thailand)"
      },
      {
        code: "COEBLALA",
        name: "BANQUE POUR LE COMMERCE EXTERIEUR LAO PUBLIC (BCEL)",
        name_en: "BANQUE POUR LE COMMERCE EXTERIEUR LAO PUBLIC (BCEL)"
      },
      {
        code: "LDBBLALA", 
        name: "Lao Development Bank Co.,Ltd (LDB)",
        name_en: "Lao Development Bank Co.,Ltd (LDB)"
      },
      {
        code: "BFLLLALA",
        name: "Banque Franco-Lao Ltd (BFL)", 
        name_en: "Banque Franco-Lao Ltd (BFL)"
      },
      {
        code: "JDBKLALA",
        name: "JOINT DEVELOPMENT BANK (JDB)",
        name_en: "JOINT DEVELOPMENT BANK (JDB)"
      },
      {
        code: "IDCBLALA",
        name: "INDOCHINA BANK LTD",
        name_en: "INDOCHINA BANK LTD"
      },
      {
        code: "STBDLALA",
        name: "ST BANK LTD",
        name_en: "ST BANK LTD"
      },
      {
        code: "LAOVLALA",
        name: "Lao-Viet Bank CO.,LTD",
        name_en: "Lao-Viet Bank CO.,LTD"
      }
    ];
  }
  static getBank(code) {
    const bank = new Banking();
    return bank.find(r => r.code === code);
  }
}
